// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"ea266348","586":"acfe16b8"}[chunkId] + ".chunk.css";
};